import kotlinx.browser.document
import org.w3c.dom.HTMLElement

/**
 * Show the "How Wiz3r works" guide as a dismissible modal overlay.
 * Used everywhere inside the logged-in app — nav ⓘ button, hamburger menu,
 * Settings menu — so the guide never navigates away from the current page.
 * Click outside the card or hit the × button to close.
 */
fun showGuideModal() {
    if (document.getElementById("guide-modal-overlay") != null) return

    val t = WebTheme.current
    val cardBg = if (t.isDark) "#0a0a0a" else t.card
    val cardBorder = if (t.isDark) "#1f1f1f" else t.border

    val overlay = document.createElement("div") as HTMLElement
    overlay.id = "guide-modal-overlay"
    overlay.setAttribute("style",
        "position: fixed; inset: 0; background: rgba(0,0,0,0.75); backdrop-filter: blur(6px); " +
        "-webkit-backdrop-filter: blur(6px); z-index: 999; display: flex; align-items: flex-start; " +
        "justify-content: center; overflow-y: auto; padding: 40px 20px; animation: modalFadeIn 0.25s ease-out;"
    )

    val card = document.createElement("div") as HTMLElement
    card.setAttribute("style",
        "position: relative; max-width: 780px; width: 100%; border-radius: 20px; " +
        "background: $cardBg; border: 1px solid $cardBorder; " +
        "box-shadow: 0 0 60px rgba(0,217,255,0.2), 0 20px 60px rgba(0,0,0,0.5); " +
        "animation: modalScaleIn 0.3s cubic-bezier(.2,.8,.2,1); overflow: hidden;"
    )

    val guidePage = GuidePage(
        onBackClick = { closeGuideModal() },
        onNavigate = null,
        isLoggedIn = true,
        onAppNavigate = null,
        asModal = true,
    )
    val guideElement = guidePage.render()
    card.appendChild(guideElement)
    guidePage.attachEventListeners(guideElement)

    val closeBtn = document.createElement("div") as HTMLElement
    closeBtn.innerHTML = "&times;"
    closeBtn.setAttribute("style",
        "position: absolute; top: 12px; right: 16px; color: ${t.textSecondary}; font-size: 28px; " +
        "cursor: pointer; z-index: 10; line-height: 1; user-select: none; padding: 4px 8px;"
    )
    closeBtn.addEventListener("click", { closeGuideModal() })
    card.appendChild(closeBtn)

    overlay.appendChild(card)
    overlay.addEventListener("click", { e ->
        if (e.target == overlay) closeGuideModal()
    })

    // Piggyback on the modalFadeIn/modalScaleIn keyframes already installed
    // by showSubscribeModal; inject a copy if they aren't there yet.
    if (document.getElementById("register-modal-styles") == null) {
        val style = document.createElement("style") as HTMLElement
        style.id = "register-modal-styles"
        style.textContent = """
            @keyframes modalFadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes modalScaleIn { from { opacity: 0; transform: scale(0.92) translateY(20px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        """.trimIndent()
        document.head?.appendChild(style)
    }

    document.body?.appendChild(overlay)
}

private fun closeGuideModal() {
    document.getElementById("guide-modal-overlay")?.let { it.parentNode?.removeChild(it) }
}
